export default function(x) {
  return x === null ? NaN : +x;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-array/src/number.js
// module id = 97
// module chunks = 0 1